import { getBackendUrl } from "../config";

function apiUrl(path) {
  const backendUrl = getBackendUrl();
  if (!backendUrl) {
    throw new Error("חסר כתובת בקאנד");
  }
  return `${backendUrl}${path}`;
}

async function parseJsonResponse(response, fallbackMessage) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new Error(data.error || data.message || fallbackMessage);
  }
  return data;
}

export async function verifyContactRequest(payload) {
  const response = await fetch(apiUrl("/api/contact-requests/verify"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return parseJsonResponse(response, "שליחת קוד האימות נכשלה");
}

export async function submitContactRequest(payload) {
  const response = await fetch(apiUrl("/api/contact-requests"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return parseJsonResponse(response, "שליחת הטופס נכשלה");
}
